export const getFleetById = (fleets, fleetId) =>
  fleets?.find((fleet) => fleet.id === fleetId) || {};

export const getFleetsById = (fleets = [], fleetIds = []) =>
  fleets?.filter((fleet) => fleetIds.includes(fleet.id));

export const getPermittedFleets = (fleets = [], permittedFleetsList = []) =>
  fleets?.filter((fleet) => permittedFleetsList.includes(fleet.id));
